import _ from 'lodash'

import i18n from '@/i18n/i18n'
import { RewardService } from '@/services/admin/RewardService'
import { errorMessage } from '@/utilities/helpers'

const { t } = i18n.global

export const namespaced = true

export const state = {
  rewards: null,
  reward: {}
}

export const mutations = {
  SET_REWARDS(state, rewards) {
    state.rewards = rewards
  },
  SET_REWARD(state, reward) {
    state.reward = reward
    let index = _.findIndex(state.rewards, item => item.id === reward.id)
    if (index === -1) {
      return
    }
    state.rewards[index] = reward
  },
  ADD_REWARD(state, reward) {
    state.rewards.push(reward)
  },
  DELETE_REWARD(state, rewardId) {
    state.rewards = _.filter(state.rewards, function (reward) {
      return reward.id !== rewardId
    })
  }
}

export const getters = {
  getRewardById: state => id => {
    return state.rewards ? state.rewards.find(reward => reward.id === id) : false
  }
}

export const actions = {
  getRewards({ commit, dispatch, state }) {
    if (state.rewards) return state.rewards

    return new Promise((resolve, reject) => {
      RewardService.getRewards()
        .then(response => {
          commit('SET_REWARDS', response.data)
          resolve(response.data)
        })
        .catch(err => {
          const notification = {
            type: 'danger',
            message:
              t('store.shared.fetching_problem', {
                element: t('store.admin.rewards.rewards')
              }) + errorMessage(err)
          }
          dispatch('notification/add', notification, {
            root: true
          })
          reject(err)
        })
    })
  },
  getReward({ commit, state, getters }, id) {
    if (id === state.reward.id) return state.reward

    let reward = getters.getRewardById(id)

    if (reward) {
      commit('SET_REWARD', reward)
      return reward
    } else {
      return new Promise(resolve => {
        RewardService.getReward(id).then(response => {
          commit('SET_REWARD', response.data)
          resolve(response.data)
        })
      })
    }
  },
  createReward({ commit, dispatch }, reward) {
    return new Promise((resolve, reject) => {
      RewardService.createReward(reward)
        .then(response => {
          commit('ADD_REWARD', response.data)
          resolve(response)
        })
        .catch(err => {
          const notification = {
            type: 'danger',
            message:
              t('store.shared.adding_problem', {
                element: t('store.admin.rewards.reward')
              }) + errorMessage(err)
          }
          dispatch('notification/add', notification, {
            root: true
          })
          reject(err)
        })
    })
  },
  updateReward({ commit, dispatch, state }, reward) {
    return new Promise((resolve, reject) => {
      RewardService.updateReward(state.reward.id, reward)
        .then(response => {
          commit('SET_REWARD', response.data)
          resolve(response)
        })
        .catch(err => {
          const notification = {
            type: 'danger',
            message:
              t('store.shared.update_error', {
                element: t('store.admin.rewards.reward')
              }) + errorMessage(err)
          }
          dispatch('notification/add', notification, {
            root: true
          })
          reject(err)
        })
    })
  },
  deleteReward({ commit, dispatch }, reward) {
    return new Promise((resolve, reject) => {
      RewardService.deleteReward(reward.id)
        .then(response => {
          commit('DELETE_REWARD', reward.id)
          resolve(response)
        })
        .catch(err => {
          const notification = {
            type: 'danger',
            message:
              t('store.shared.delete_error', {
                element: t('store.admin.rewards.reward')
              }) + errorMessage(err)
          }
          dispatch('notification/add', notification, {
            root: true
          })
          reject(err)
        })
    })
  },
  uploadImage({ dispatch }, params) {
    return new Promise((resolve, reject) => {
      RewardService.uploadImage(params.id, params.form)
        .then(response => {
          const notification = {
            type: 'success',
            message: t('store.shared.uploaded', {
              element: t('store.admin.rewards.reward_image')
            })
          }
          dispatch('notification/add', notification, {
            root: true
          })
          resolve(response.data)
        })
        .catch(err => {
          const notification = {
            type: 'danger',
            message:
              t('store.shared.uploading_error', {
                element: t('store.admin.rewards.reward_image')
              }) + errorMessage(err)
          }
          dispatch('notification/add', notification, {
            root: true
          })
          reject(err)
        })
    })
  }
}
